/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Insights_Key_Points_BodyInputs */

const en_why_listening_insights_key_points_body = /** @type {(inputs: Why_Listening_Insights_Key_Points_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The main findings as a list you can scan in seconds.`)
};

const es_why_listening_insights_key_points_body = /** @type {(inputs: Why_Listening_Insights_Key_Points_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los hallazgos principales en una lista que puedes repasar en segundos.`)
};

/**
* | output |
* | --- |
* | "The main findings as a list you can scan in seconds." |
*
* @param {Why_Listening_Insights_Key_Points_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_insights_key_points_body = /** @type {((inputs?: Why_Listening_Insights_Key_Points_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Insights_Key_Points_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_insights_key_points_body(inputs)
	return en_why_listening_insights_key_points_body(inputs)
});